import Vue from 'vue';
import Component from 'vue-class-component';
import _ from 'lodash';

@Component
export default class ProductListMixin extends Vue {
  // data
  productsListMap: { [key: string]: string } = {
    EgrnObject: 'egrn',
    EgrnObjectFast: 'egrn',
    EgrnRightList: 'rightList',
    EgrnRightListFast: 'rightList',
    RiskAssessment: 'risk',
    RiskAssessmentFast: 'risk',
  };

  public mapOfficialProducts(products: Product[]): OfficialProductMap {
    const productsMap: OfficialProductMap = {};

    _.forEach(products, (product: Product) => {
      if (product.product_name in this.productsListMap) {
        const groupName = this.productsListMap[product.product_name];

        if (!(groupName in productsMap)) {
          productsMap[groupName] = { default: null, fast: null };
        }

        if (_.includes(product.product_name, 'Fast')) {
          productsMap[groupName].fast = product;
        } else {
          productsMap[groupName].default = product;
        }
      }
    });

    return productsMap;
  }
}
